'use client';

import { faArrowRightLong } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import EventNames from 'src/analytics/EventNames';
import {
    ButtonAction,
    DestinationCategory,
    PageType,
} from 'src/analytics/EventProps';
import { trackClick } from 'src/analytics/Events';
import { BrandType } from 'src/constants/Brands';
import { Vertical } from 'src/constants/Verticals';
type QuizLinkProps = {
    item: {
        title: string;
        vertical: Vertical;
        url: string;
    };
    brand: BrandType;
};

function QuizLink({ item, brand }: QuizLinkProps) {
    return (
        <Link
            href={item.url}
            onClick={() => {
                trackClick(EventNames.LANDING_PAGE_BUTTON_CLICKED, {
                    destination_category: DestinationCategory.QUIZ,
                    button_action: ButtonAction.DIRECT,
                    brand,
                    page_type: PageType.PREQUIZ,
                    label: item.title,
                    destination_url: window.location.origin + item.url,
                    destination_vertical: item.vertical,
                    destination_brand: brand,
                });
            }}
        >
            <h5>{item.title}</h5>
            <FontAwesomeIcon icon={faArrowRightLong} />
        </Link>
    );
}

export default QuizLink;
